import {
  UserProfileAuthClientResponse,
  PhiInsuranceStatus,
  PhiAddressStatus,
} from "../../recoil/types";
import { FileUploadInfo } from "../Insurance/InsuranceFileUploader";

export const getRelationshipToInsured = (
  self?: boolean,
  dependent?: boolean,
  other?: boolean,
): "Self" | "Dependent" | "Other" => {
  if (self) {
    return "Self";
  }
  if (dependent) {
    return "Dependent";
  }
  if (other) {
    return "Other";
  }
  return "Self";
};

export const getInsuredParameter = (
  insured?: "Self" | "Dependent" | "Other",
):
  | "relationshipToPolicyOwnerSelf"
  | "relationshipToPolicyOwnerDependent"
  | "relationshipToPolicyOwnerOther"
  | "" => {
  if (insured === "Self") {
    return "relationshipToPolicyOwnerSelf";
  }
  if (insured === "Dependent") {
    return "relationshipToPolicyOwnerDependent";
  }
  if (insured === "Other") {
    return "relationshipToPolicyOwnerOther";
  }
  return "";
};

export interface PatientInsuranceInfo {
  billToInsuranceType?: "Entry" | "Upload";
  insuranceCompanyName: string;
  groupId: string;
  memberId: string;
  policyOwnerName: string;
  policyOwnerDob: string;
  relationshipToPolicyOwnerSelf: boolean;
  relationshipToPolicyOwnerDependent: boolean;
  relationshipToPolicyOwnerOther: boolean;
  insuranceFileUrls: FileUploadInfo;
  checkError: boolean;
}

export interface FullAddress {
  fullAddress: string;
  streetAddress: string;
  state: string;
  city: string;
  zipCode: string;
  aptUnit: string;
}

export const statesArray = [
  "AK - Alaska",
  "AL - Alabama",
  "AR - Arkansas",
  "AS - American Samoa",
  "AZ - Arizona",
  "CA - California",
  "CO - Colorado",
  "CT - Connecticut",
  "DC - District of Columbia",
  "DE - Delaware",
  "FL - Florida",
  "GA - Georgia",
  "GU - Guam",
  "HI - Hawaii",
  "IA - Iowa",
  "ID - Idaho",
  "IL - Illinois",
  "IN - Indiana",
  "KS - Kansas",
  "KY - Kentucky",
  "LA - Louisiana",
  "MA - Massachusetts",
  "MD - Maryland",
  "ME - Maine",
  "MI - Michigan",
  "MN - Minnesota",
  "MO - Missouri",
  "MS - Mississippi",
  "MT - Montana",
  "NC - North Carolina",
  "ND - North Dakota",
  "NE - Nebraska",
  "NH - New Hampshire",
  "NJ - New Jersey",
  "NM - New Mexico",
  "NV - Nevada",
  "NY - New York",
  "OH - Ohio",
  "OK - Oklahoma",
  "OR - Oregon",
  "PA - Pennsylvania",
  "PR - Puerto Rico",
  "RI - Rhode Island",
  "SC - South Carolina",
  "SD - South Dakota",
  "TN - Tennessee",
  "TX - Texas",
  "UT - Utah",
  "VA - Virginia",
  "VI - Virgin Islands",
  "VT - Vermont",
  "WA - Washington",
  "WI - Wisconsin",
  "WV - West Virginia",
  "WY - Wyoming",
];

export const isMissingBillingInformation = (
  patientInfo?: UserProfileAuthClientResponse,
): boolean => patientInfo?.phi.ins_status === PhiInsuranceStatus.Required;

export const isMissingBillingAddress = (
  patientInfo?: UserProfileAuthClientResponse,
): boolean => patientInfo?.phi.address_status === PhiAddressStatus.Required;
